<template>
  <div class="container-lg">
    <div class="row">
      <div class="col-md">
        <b-card>
          <h2>Process</h2>
          <b-tabs>
            <b-tab title="Process">
              <o-form-wrapper
                v-model="item"
                :server-errors="_se"
                :v="$v.item"
                :schema="schema"
                :form-state="formState"
              >
                <o-widget-wrapper
                  :schema="schema"
                  name="name"
                  :validators="$v.item"
                  :server-errors="_se"
                  :form-state="formState"
                >
                  <o-text-field
                    v-model="item.name"
                    :form-state="formState"
                    name="name"
                    :validators="$v.item"
                    :server-errors="_se"
                    v-bind="schema.fields.name"
                  ></o-text-field>
                </o-widget-wrapper>
                <o-widget-wrapper
                  :schema="schema"
                  name="model_type"
                  :validators="$v.item"
                  :server-errors="_se"
                  :form-state="formState"
                >
                  <o-select
                    v-model="item.model_type"
                    :items="model_names"
                    text-field="text"
                    value-field="value"
                    sort-field="text"
                    :form-state="formState"
                    name="model_type"
                    :validators="$v.item"
                    :server-errors="_se"
                    v-bind="schema.fields.model_type"
                  >
                  </o-select>
                  <!-- <o-text-field v-model="item.model_type" :form-state="formState" name="model_type" :validators="$v.item"
                  :server-errors="_se" v-bind="schema.fields.model_type"></o-text-field> -->
                </o-widget-wrapper>
              </o-form-wrapper>
            </b-tab>
            <b-tab title="Roles">
              <items-editor
                @input="updateRoles"
                :items="item.roles"
                @create="newUserRole"
              >
                <template v-slot:list="slotProps">
                  {{ slotProps.item.description }}</template
                >
                <template v-slot:edit="slotProps">
                  <h1>{{ slotProps.item.description }}</h1>
                  <user-role-item-form
                    :item="slotProps.item"
                    :level="1"
                    :server-errors="_se"
                    :form-state="formState"
                  >
                  </user-role-item-form>
                </template>
              </items-editor>
            </b-tab>
            <b-tab title="Flow">
              <items-editor
                :enabledBadge="true"
                @input="updateProcessStates"
                :items="item.states"
                @create="newState"
                item-description="name"
              >
                <template v-slot:list="slotProps">
                  {{ slotProps.item.name }}</template
                >
                <template v-slot:edit="{ item: selectedState }">
                  <b-card>
                    <h1>{{ selectedState.name }}</h1>
                    <b-tabs>
                      <b-tab title="State">
                        <state-item-form
                          :codeStateTypeItems="codeStateTypeItems"
                          :codeActivityTypeItems="codeActivityTypeItems"
                          :item-roles="item.roles"
                          :item="selectedState"
                          :level="1"
                          :server-errors="_se"
                          :form-state="formState"
                        ></state-item-form>
                      </b-tab>
                      <b-tab title="Triggers">
                        <items-editor
                          @input="updateProcessTriggers"
                          :items="selectedState.triggers"
                          @create="newTrigger(selectedState)"
                          item-description="name"
                        >
                          <template v-slot:list="slotProps">
                            {{ slotProps.item.name }}</template
                          >
                          <template v-slot:edit="{ item: selectedTrigger }">
                            <trigger-item-form
                              :codeTriggerTypeItems="codeTriggerTypeItems"
                              :item-roles="item.roles"
                              :item="selectedTrigger"
                              :level="1"
                              :server-errors="_se"
                              :form-state="formState"
                            >
                            </trigger-item-form>
                          </template>
                        </items-editor>
                      </b-tab>
                      <b-tab title="Transitions">
                        <items-editor
                          @input="updateProcessTransition"
                          :items="selectedState.transitions"
                          @create="newTransition(selectedState)"
                          item-description="name"
                        >
                          <template v-slot:list="slotProps">
                            {{ slotProps.item.name }}</template
                          >
                          <template v-slot:edit="{ item: selectedTransition }">
                            <transition-item-form
                              :item-states="item.states"
                              :item-triggers="selectedState.triggers"
                              :item="selectedTransition"
                              :level="1"
                              :server-errors="_se"
                              :form-state="formState"
                            >
                            </transition-item-form>
                          </template>
                        </items-editor>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </template>
              </items-editor>
            </b-tab>
            <b-tab title="Diagram" lazy>
              <div>
                <diagram-page
                  v-if="item.states.length > 0"
                  :items="item.states"
                ></diagram-page>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";

import ItemsEditor from "@/vue-workflow/ItemsEditor.vue";
// import { default as UserRoleFormCards } from '../../user_role/components/ItemFormCards';
import { default as UserRoleItemForm } from "../../user_role/components/ItemForm.vue";
import { default as StateItemForm } from "../../process_state/components/ItemForm.vue";
import { default as TriggerItemForm } from "../../process_trigger/components/ItemForm.vue";
import { default as TransitionItemForm } from "../../process_transition/components/ItemForm.vue";
import { CreateDefaultItem } from "@/vue-ocom/schema/schema_utils.js";
import { code_state_type } from "../../../lib/code_tables/code_state_type.js";
import { code_activity_type } from "../../../lib/code_tables/code_activity_type.js";
import { code_trigger_type } from "../../../lib/code_tables/code_trigger_type.js";

import DiagramPage from "../pages/DiagramPage.vue";
import appSchema from "../../../../app/schema/index.js";
export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Process"),
  ],
  components: {
    ItemsEditor,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,
    OCheckbox,
    OSelect,
    OTextField,
    UserRoleItemForm,
    StateItemForm,
    TriggerItemForm,
    TransitionItemForm,
    DiagramPage,
  },
  props: {
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    all_schema: appSchema,
    all_schema_name: [],
    codeStateTypeItems: [],
    codeActivityTypeItems: [],
    codeTriggerTypeItems: [],
    schemaModel: cleanUpModel(schema.Process, {}),
  }),
  methods: {
    updateFormState() {
      if (this.formState) this.formState.dirty = true;
    },
    updateProcessTransition(items) {
      this.updateFormState();
      this.selectedState.transitions = items;
    },
    updateProcessTriggers(items) {
      this.updateFormState();
      this.selectedState.triggers = items;
    },
    updateProcessStates(items) {
      this.item.states = items;
      this.updateFormState();
    },
    updateRoles(items) {
      this.item.roles = items;
      this.updateFormState();
    },
    newUserRole() {
      this.item.roles.push(CreateDefaultItem(schema.UserRole));
    },
    newState() {
      this.item.states.push(CreateDefaultItem(schema.ProcessState));
    },
    newTrigger(state) {
      state.triggers.push(CreateDefaultItem(schema.ProcessTrigger));
    },
    newTransition(state) {
      state.transitions.push(CreateDefaultItem(schema.ProcessTransition));
    },
  },
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
    model_names() {
      for (const [key, value] of Object.entries(this.all_schema)) {
        this.all_schema_name.push({
          text: value.verbose_name,
          value: value.name,
        });
      }
      return this.all_schema_name;
    },
  },
  created() {
    this.codeStateTypeItems = code_state_type;
    this.codeActivityTypeItems = code_activity_type;
    this.codeTriggerTypeItems = code_trigger_type;
  },
};
</script>

<style>
.tab-content {
  margin-top: 1.5rem;
}
</style>
